function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

function currentSearchParams() {
  const params = new URLSearchParams(window.location.search)
  const forward = new URLSearchParams()

  const ransackKeys = [
    'q[check_in]', 'q[check_out]', 'q[max_occupancy_gteq]',
    'q[bedrooms_gteq]', 'q[hot_tub]', 'q[pets_friendly_eq]',
    'q[air_conditioning]', 'q[sharc_passes_included]',
    'q[luxury_retreat]', 'q[game_table]', 'q[king_beds]',
    'q[single_floor]', 'q[ev_charger]', 'q[family_loving]',
    'q[wifi]', 'q[is_accessible_eq]', 'q[updated]', 'q[special]',
    'q[caldera_springs]', 'q[price_from]', 'q[price_to]', 'q[review_score_gteq]'
  ]
  const legacyKeys = ['arrival', 'departure', 'guest_count', 'pets', 'promo_code']

  for (const key of [...ransackKeys, ...legacyKeys]) {
    const val = params.get(key)
    if (val) forward.set(key, val)
  }

  const qs = forward.toString()
  return qs ? `?${qs}` : ''
}

function buildLinkPill(url, label) {
  const fullUrl = url
  url = url.replace(/^https?:\/\/(?:www\.)?benningtonsunriver\.com/, '')
  const isLocal = url.startsWith('/')

  if (isLocal && url.match(/\/properties\/[a-z0-9-]+\/?$/i) && !url.includes('?')) {
    url = url + currentSearchParams()
  }

  if (!label) {
    if (url.includes('/reservations/new')) {
      label = 'Book now'
    } else if (url.match(/\/properties\/[a-z0-9-]+/i)) {
      const slug = url.match(/\/properties\/([a-z0-9-]+)/i)?.[1]
      label = slug ? slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'View property'
    } else {
      try {
        label = new URL(fullUrl).hostname.replace('www.', '')
      } catch {
        label = 'Open link'
      }
    }
  }

  const cleanUrl = url.replace(/\?.*$/, '')
  const escapedUrl = escapeHtml(url)
  const copyUrl = escapeHtml(isLocal ? `https://www.benningtonsunriver.com${cleanUrl}` : url)
  const escapedLabel = escapeHtml(label)

  return `<span class="chat-link-pill">` +
    `<svg class="chat-link-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">` +
      `<path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-1.102-4.243a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>` +
    `</svg>` +
    `<a href="${escapedUrl}" title="${copyUrl}">${escapedLabel}</a>` +
    `<button type="button" class="chat-link-copy" data-url="${copyUrl}" title="Copy link">` +
      `<svg class="copy-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">` +
        `<path stroke-linecap="round" stroke-linejoin="round" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"/>` +
      `</svg>` +
      `<svg class="copy-check hidden" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">` +
        `<path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>` +
      `</svg>` +
    `</button>` +
  `</span>`
}

export function formatMarkdown(text) {
  if (!text) return ''

  const links = []
  const phones = []
  let processed = text

  processed = processed.replace(/\[([^\]]+)\]\(((?:https?:\/\/|\/)[^)]+)\)/g, (_, linkText, url) => {
    const idx = links.length
    links.push({ url, label: linkText })
    return `%%LINK${idx}%%`
  })

  // Exclude "*" so a bolded URL (**/properties/x**) keeps its ** pair intact
  // for the bold pass instead of half-swallowing it into the link.
  processed = processed.replace(/(\/properties\/[^\s<)\]*]+)/g, (_, url) => {
    url = url.replace(/[.,;:!?'"]+$/, '')
    url = url.replace(/([=&/][a-z0-9-]+)[A-Z][a-z].*$/, '$1')
    const idx = links.length
    links.push({ url, label: null })
    return `%%LINK${idx}%%`
  })

  processed = processed.replace(/(https?:\/\/[^\s<)\]*]+)/g, (_, url) => {
    url = url.replace(/([=&/]\w+?)[A-Z][a-z].*$/, '$1')
    url = url.replace(/[.,;:!?'"]+$/, '')
    const idx = links.length
    links.push({ url, label: null })
    return `%%LINK${idx}%%`
  })

  processed = processed.replace(/(?<!\d)((?:\+?1[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4})(?!\d)/g, (_, phone) => {
    const digits = phone.replace(/\D/g, '')
    if (digits.length < 10) return phone
    const idx = phones.length
    phones.push(phone.trim())
    return `%%PHONE${idx}%%`
  })

  let html = escapeHtml(processed)

  links.forEach((link, idx) => {
    html = html.replace(`%%LINK${idx}%%`, buildLinkPill(link.url, link.label))
  })

  phones.forEach((phone, idx) => {
    const digits = phone.replace(/\D/g, '')
    const tel = digits.length === 11 ? `+${digits}` : `+1${digits}`
    html = html.replace(`%%PHONE${idx}%%`,
      `<a href="tel:${tel}" class="chat-phone-link"><svg class="chat-phone-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"/></svg>${escapeHtml(phone)}</a>`)
  })

  html = html.replace(/\*\*([^*]+)\*\*/g, "<strong class='font-semibold text-gray-900'>$1</strong>")

  html = html.replace(/(?:^|\n)[-•]\s+(.+)/gm, '<li>$1</li>')
  html = html.replace(/((?:<li>.*?<\/li>\s*)+)/gs, '<ul class="chat-list">$1</ul>')

  html = html.replace(/(?:^|\n)\d+\.\s+(.+)/gm, '<li>$1</li>')
  html = html.replace(/((?:<li>(?!.*class=).*?<\/li>\s*)+)/gs, '<ol class="chat-list chat-list-ordered">$1</ol>')

  html = html.replace(/\n\n/g, '</p><p class="mt-2">')
  html = html.replace(/\n/g, '<br>')

  return `<p class="m-0">${html}</p>`
}

export { escapeHtml }
